export interface ClientSecretData {
  id: string;
  createdBy: string;
  lastUsedTime: string;
  secretSuffix: string;
  status: string;
  createTime: string;
  updateTime: string;
  expireTime: string;
  plainSecret?: string;
}

export interface ClientDetailsData {
  accessTokenExpiry?: string;
  scopes?: Array<string>;
  clientType?: EApplicationType;
  customClaims?: Array<string>;
  disallowScalekitApiAccess?: boolean;
  enforcePkce?: boolean;
  grantTypes?: Array<string>;
  name?: string;
}

export interface ApiConfigData extends ClientDetailsData {
  id: string;
  keyId: string;
  redirectUris: string[];
  defaultRedirectUri: string;
  secrets: ClientSecretData[];
  createTime: string;
  updateTime: string;
  postLogoutRedirectUris: string[];
  backChannelLogoutUris: string[];
  initiateLoginUri: string;
  postLoginUris: string[];
}

export interface ApiConfigUpdateRequest
  extends APIConfigMetaDetailsUpdateRequest {
  redirectUris?: string[];
  defaultRedirectUri?: string;
  postLogoutRedirectUris?: string[];
  backChannelLogoutUris?: string[];
  initiateLoginUri?: string;
  postLoginUris?: string[];
}

export interface APIConfigMetaDetailsUpdateRequest {
  name?: string;
  accessTokenExpiry?: string;
  disallowScalekitApiAccess?: boolean;
  enforcePkce?: boolean;
}

export interface ApiConfigUpdateResponse {
  client: ApiConfigData;
}

export interface ApiConfigResponse {
  nextPageToken: string;
  totalSize: number;
  clients: ApiConfigData[];
}

export interface CreateClientSecretResponse {
  plainSecret: string;
  secret: ClientSecretData;
}

export enum EApplicationType {
  WEB_APPLICATION = 'WEB_APP',
  SINGLE_PAGE_APPLICATION = 'SPA',
  NATIVE_APPLICATION = 'NTV',
  DEFAULT_APPLICATION = 'ENV'
}

export interface CreateNewClientRequest {
  name: string;
  clientType: EApplicationType;
}
